import type { ReactNode } from 'react'

// 시트 아래 상태 줄 — 왼쪽은 지금 칸이 붉은·노란 이유(없으면 도움말), 오른쪽은 칸 표시 범례.
// 시트 칸의 표시는 색만이 아니라 모양(왼쪽 막대·아래 막대·삼각형)도 다르다 — index.css 의 dsg-cell-* · sheet-swatch

/** 지금 칸의 표시 이유 — error = 붉은 칸(점검·수식 오류·명세에 없음), warn = 노란 칸(겹침) */
export interface CellNote { tone: 'error' | 'warn'; text: string }

export type LegendKey = 'invalid' | 'dup' | 'formula' | 'noaddr'
const LEGEND: Record<LegendKey, { swatch: string; label: string; title: string }> = {
  invalid: { swatch: 'sw-invalid', label: '고칠 칸', title: '전송 전 점검에 걸렸거나 계산하지 못한 수식 — 칸을 고르면 이유가 왼쪽에 나옵니다' },
  dup: { swatch: 'sw-dup', label: '겹침', title: '다른 칸과 값이 같습니다' },
  formula: { swatch: 'sw-formula', label: '수식', title: '= 로 계산된 값 (F2 로 수식 원문)' },
  noaddr: { swatch: 'sw-noaddr', label: '주소 없음', title: '주소가 없는 태그는 Edge 적용과 태그 개수에서 빠집니다' },
}

export function SheetLegend({ items }: { items: LegendKey[] }) {
  return (
    <span className="flex items-center gap-3 text-gray-500">
      {items.map(k => (
        <span key={k} className="flex items-center gap-1 whitespace-nowrap" title={LEGEND[k].title}>
          <span className={`sheet-swatch ${LEGEND[k].swatch}`} />{LEGEND[k].label}
        </span>
      ))}
    </span>
  )
}

export function NoteText({ note, fallback }: { note: CellNote | null; fallback?: ReactNode }) {
  if (!note) return <span className="text-gray-500 truncate">{fallback}</span>
  return (
    <span className={`flex items-center gap-1.5 min-w-0 font-medium ${note.tone === 'error' ? 'text-red-700' : 'text-amber-700'}`}>
      <span className={`sheet-swatch shrink-0 ${note.tone === 'error' ? 'sw-invalid' : 'sw-dup'}`} />
      <span className="truncate">{note.text}</span>
    </span>
  )
}

/** 편집 모드 시트 아래 상태 줄 */
export default function SheetStatus({ note, hint, legend }: { note: CellNote | null; hint?: ReactNode; legend: LegendKey[] }) {
  return (
    <div className="flex items-center gap-4 mx-3 h-7 px-3 text-xs bg-surface border-x border-t border-gray-200 shrink-0 min-w-0">
      <NoteText note={note} fallback={hint} />
      <span className="ml-auto shrink-0"><SheetLegend items={legend} /></span>
    </div>
  )
}
